import React from "react";
import { CircularProgress, IconButton, Tooltip } from "@mui/material";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import RotateRightIcon from "@mui/icons-material/RotateRight";
import CheckIcon from "@mui/icons-material/Check";
import ReplayIcon from "@mui/icons-material/Replay";
import CustomButton from "../../../../components/buttons/CustomButton";
import styles from "./CranialSteps.module.css";

const rotateButtonSx = {
  border: "1px solid rgba(90, 128, 251, 0.2)",
  borderRadius: "12px",
  color: "#5A80FB",
};

/**
 * Preview of the prepared photo with 90-degree rotation before validation.
 */
function ImagePreview({ image, sourceType, isPreparing, onRotate, onUsePhoto, onRetake }) {
  if (!image) return null;

  return (
    <div className={styles.card}>
      <span className={styles.eyebrow}>Prévia</span>
      <h3 className={styles.cardTitle}>Confira a foto</h3>
      <p className={styles.cardText}>
        Gire a foto se necessário para que o nariz fique voltado para o topo da imagem.
      </p>

      <div className={styles.imageFrame} style={{ marginTop: "1rem" }}>
        <img src={image.display.url} alt="Prévia da foto" className={styles.previewImage} />
        {isPreparing && (
          <div className={styles.imageBusy}>
            <CircularProgress />
          </div>
        )}
      </div>

      <div className={styles.toolbar}>
        <Tooltip title="Girar para a esquerda">
          <span>
            <IconButton sx={rotateButtonSx} onClick={() => onRotate(-90)} disabled={isPreparing} aria-label="Girar para a esquerda">
              <RotateLeftIcon />
            </IconButton>
          </span>
        </Tooltip>
        <Tooltip title="Girar para a direita">
          <span>
            <IconButton sx={rotateButtonSx} onClick={() => onRotate(90)} disabled={isPreparing} aria-label="Girar para a direita">
              <RotateRightIcon />
            </IconButton>
          </span>
        </Tooltip>
      </div>

      <div className={styles.actions}>
        <CustomButton
          variant="outlined"
          style="primary"
          label={sourceType === "camera" ? "Tirar novamente" : "Escolher outra"}
          icon={<ReplayIcon />}
          onClick={onRetake}
          enabled={!isPreparing}
        />
        <CustomButton
          variant="contained"
          style="primary"
          label="Usar esta foto"
          icon={<CheckIcon />}
          onClick={onUsePhoto}
          enabled={!isPreparing}
        />
      </div>
    </div>
  );
}

export default ImagePreview;
